import { hexToRgbA } from '@/helpers';
import { AgenciesSelectors } from '@/store/agencies';
import { MatchedPFSelectors } from '@/store/matchedPF/matchedPF.selector';
import { createSelector } from '@reduxjs/toolkit';
import moment from 'moment';
const getMatchedGrants = (state) => state.matchedGrants.data;
const getLoading = (state) => state.matchedGrants.loading;
const makeCustomerMatchedGrants = createSelector([getMatchedGrants], (matchedGrants) => {
    return matchedGrants.map((matchedGrant) => {
        const { _id: matchedGrantId = '', solicitation = {}, grant = {}, } = matchedGrant;
        const { title = '', topicId = '', topic_title = '', _id: grantId = '', awards_phaseI = '', awards_phaseII = '', } = grant;
        const { program = '', open_date = '', close_date = '', agency_abbr = '', solicitation_title = '', solicitation_number = '', } = solicitation;
        const formattedOpenDate = open_date ? moment(open_date).format('YYYY-MM-DD') : '';
        const formattedCloseDate = close_date ? moment(close_date).format('YYYY-MM-DD') : '';
        const awardsPhaseI = awards_phaseI === 'none' || awards_phaseI === '' ? 0 : parseInt(awards_phaseI, 10);
        const awardsPhaseII = awards_phaseII === 'none' || awards_phaseII === '' ? 0 : parseInt(awards_phaseII, 10);
        const grantAmount = awardsPhaseI + awardsPhaseII;
        const formattedGrantAmount = grantAmount.toLocaleString('en-US');
        return {
            grantId,
            topicId,
            program,
            grantAmount,
            awardsPhaseI,
            awardsPhaseII,
            matchedGrantId,
            formattedGrantAmount,
            agencyAbbr: agency_abbr,
            openDate: formattedOpenDate,
            closeDate: formattedCloseDate,
            grantTitle: topic_title || title,
            solicitationTitle: solicitation_title,
            solicitationNumber: solicitation_number,
        };
    });
});
const makeCustomerGrantsMetrics = createSelector([makeCustomerMatchedGrants], (customerGrants) => {
    if (!customerGrants || !customerGrants.length) {
        return {
            totalGrantsAmount: 0,
            totalGrants: 0,
            totalPfs: 0,
            totalAmount: 0,
            avgGrantAmount: 0,
        };
    }
    const totalAmount = customerGrants.reduce((acc, grant) => acc + grant.grantAmount, 0);
    const avgGrantAmount = totalAmount / customerGrants.length;
    const formattedAvgAmount = Math.round(avgGrantAmount).toLocaleString('en-US');
    const formattedTotalAmount = totalAmount.toLocaleString('en-US');
    return {
        avgGrantAmount,
        formattedAvgAmount,
        totalGrantsAmount: totalAmount,
        totalGrants: customerGrants.length,
        formattedAmount: formattedTotalAmount,
    };
});
const makeGraphData = createSelector([makeCustomerMatchedGrants], (matchedGrants) => {
    const agencyAmountMap = {};
    matchedGrants.forEach((grant) => {
        const { agencyAbbr, program } = grant;
        if (!agencyAmountMap[agencyAbbr]) {
            agencyAmountMap[agencyAbbr] = { small: 0, federal: 0 };
        }
        if (program !== '') {
            agencyAmountMap[agencyAbbr].small += 1;
        }
        else {
            agencyAmountMap[agencyAbbr].federal += 1;
        }
    });
    return agencyAmountMap;
});
const makeGrantTotalsByType = createSelector([makeCustomerMatchedGrants, MatchedPFSelectors.getMatchedPFCount], (matchedGrants, pfcounts) => {
    return matchedGrants.reduce((acc, curr) => {
        if (curr.program) {
            acc['Small Business'] += 1;
        }
        else {
            acc['Federal Opps'] += 1;
        }
        return acc;
    }, {
        'Small Business': 0,
        'Federal Opps': 0,
        'Private Foundations': pfcounts,
    });
});
const makeGrantDataForDoughnut = createSelector([makeCustomerMatchedGrants, AgenciesSelectors.getAgencies], (matchedGrants, agencies) => {
    const reducedGrants = matchedGrants.reduce((acc, curr) => {
        const agency = agencies.find(({ acronym }) => acronym === curr.agencyAbbr);
        if (acc[curr.agencyAbbr]) {
            acc[curr.agencyAbbr].amount = acc[curr.agencyAbbr].amount += curr.grantAmount;
        }
        else {
            acc[curr.agencyAbbr] = {
                amount: curr.grantAmount,
                backgroundColor: (agency && agency.textColor) || '#94A3B8',
            };
        }
        return acc;
    }, {});
    return Object.entries(reducedGrants).reduce((acc, curr) => {
        const [k, { amount, backgroundColor }] = curr;
        acc.labels.push(k);
        acc.datasets[0].data.push(amount);
        acc.datasets[0].backgroundColor.push(hexToRgbA(backgroundColor));
        return acc;
    }, {
        labels: [],
        datasets: [{ data: [], backgroundColor: [] }],
    });
    /*   {
      agencyAbbr: 'NSF',
      awardsPhaseI: 12000000,
      awardsPhaseII: 0,
      closeDate: '2025-10-22',
      formattedGrantAmount: '12,000,000',
      grantAmount: 12000000,
      grantId: '66d8007c603864acd880c958',
      grantTitle: 'Computer and Information Science and Engineering (CISE): Core Programs',
      matchedGrantId: '68419b25bac8ce31ff79ae16',
      openDate: '2024-07-10',
      program: '',
      solicitationNumber: '24-589',
      solicitationTitle: '24-589',
      topicId: '24-589__24-589',
    }*/
});
export const MatchedGrantsSelectors = {
    getLoading,
    getMatchedGrants,
    makeCustomerMatchedGrants,
    makeCustomerGrantsMetrics,
    makeGraphData,
    makeGrantTotalsByType,
    makeGrantDataForDoughnut,
};
